import classNames from 'classnames'
import React from 'react'
import { IChildrenProp, IColorProp } from 'types/components/components.interface'

interface IButtonLabelProps extends IChildrenProp, IColorProp {}

const ButtonLabel = ({children, color}: IButtonLabelProps) => {
    const className = classNames(['button-label', color])
  return (
    <div className={className}>{children}</div>
  )
}

export default ButtonLabel